import { isMobile, isTablet } from "@/js/helpers/mediaQueryHelper";
import { isBgVideoView } from "@/js/helpers/viewModeHelper";

const SELECTOR = ".js-main-menu-wrapper";
const TOGGLE_SELECTOR = ".js-main-menu__toggle";
const MENU_SELECTOR = ".js-main-menu";
const PAGE_TITLE_SELECTOR = ".js-page-title";
const IS_OPEN_CLASSNAME = "is-open";
const BODY_NO_SCROLL_CLASSNAME = "no-scroll";

class MainMenu {
    static attach(container) {
        const mainMenuElements = container.querySelectorAll(SELECTOR);
        if (mainMenuElements) {
            [...mainMenuElements].forEach((mainMenuElement) => {
                /* eslint-disable-next-line no-unused-vars */
                const mainmenu = new MainMenu(mainMenuElement);
            });
        }
    }

    constructor(wrapper) {
        this.wrapperElement =
            typeof wrapper === "string" ? document.querySelector(wrapper) : wrapper;
        if (this.wrapperElement) {
            this.toggleButtonElement = this.wrapperElement.querySelector(TOGGLE_SELECTOR);
            this.menuElement = this.wrapperElement.querySelector(MENU_SELECTOR);
        }
        this.pageTitleElement = document.querySelector(PAGE_TITLE_SELECTOR);

        this.isOpen = false;
        this.setupToggleButton();

        this.watchResize();
        this.render();
    }

    watchResize() {
        let inProcess = false;

        window.addEventListener(
            "resize",
            () => {
                if (!inProcess) {
                    inProcess = true;
                    window.requestAnimationFrame(() => {
                        this.render();
                        inProcess = false;
                    });
                }
            },
            { passive: true }
        );
    }

    setupToggleButton() {
        if (this.toggleButtonElement) {
            this.toggleButtonElement.addEventListener("click", () => {
                this.toggleIsOpen();
            });
        }
    }

    toggleIsOpen() {
        this.isOpen = !this.isOpen;
        this.render();
    }

    render() {
        if (this.isOpen) {
            if (isTablet()) {
                document.body.classList.add(BODY_NO_SCROLL_CLASSNAME);
            } else {
                document.body.classList.remove(BODY_NO_SCROLL_CLASSNAME);
            }
            this.wrapperElement.classList.add(IS_OPEN_CLASSNAME);
        } else {
            document.body.classList.remove(BODY_NO_SCROLL_CLASSNAME);
            this.wrapperElement.classList.remove(IS_OPEN_CLASSNAME);
        }

        if (this.pageTitleElement) {
            if (isMobile()) {
                this.pageTitleElement.style.paddingRight = `${this.toggleButtonElement.clientWidth}px`;
            } else if (isTablet() && isBgVideoView()) {
                this.pageTitleElement.style.paddingRight = `${this.toggleButtonElement.clientWidth}px`;
            } else {
                this.pageTitleElement.style.paddingRight = 0;
            }
        }
    }
}

export { MainMenu };
